import { styled } from '@mui/material'

const ScrollableContainer = styled('div')(({ theme }) => ({
  overflowX: 'auto',
  overflowY: 'hidden',
  '&::-webkit-scrollbar': {
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: theme.palette.grey[100],
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.grey[400],
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: theme.palette.grey[500],
    },
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.grey[400]} ${theme.palette.grey[100]}`,

  '& .MuiTabs-root': {
    minWidth: 'max-content',
  },

  '& .MuiTabs-flexContainer': {
    overflowX: 'visible',
    flexWrap: 'nowrap',
  },

  '& .MuiTabs-scroller': {
    overflowX: 'auto !important',
  },
}))

export default ScrollableContainer
